import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { useFullscreen } from '@vueuse/core';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isFullscreen, toggle } = useFullscreen();

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "screen-full",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args)))
  }, [
    (!_unref(isFullscreen))
      ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          className: "toggle-icon",
          title: "全屏",
          icon: "full_screen"
        }))
      : (_openBlock(), _createBlock(_component_svg_icon, {
          key: 1,
          title: "全屏",
          icon: "cancel_full_screen",
          className: "toggle-icon"
        }))
  ]))
}
}

})